import { render, staticRenderFns } from "./assessment.vue?vue&type=template&id=cce9a9a0&scoped=true"
import script from "./assessment.vue?vue&type=script&lang=js"
export * from "./assessment.vue?vue&type=script&lang=js"
import style0 from "./assessment.vue?vue&type=style&index=0&id=cce9a9a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce9a9a0",
  null
  
)

export default component.exports